import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/EggsLrg.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>April 1, 2024</ClientTag>
                            <Title>Egg-cellent Health</Title>
                            <TechniqueTitle>
                            What Health Benefits do Eggs Provide? 
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>With Easter weekend coming to a close, I 
                        thought this was the perfect time to discuss the health benefits 
                        of all the eggs we have been consuming (hopefully some of the 
                        chicken kind and not just the Cadbury kind)!</p>
                    <p className='content'>Eggs have an abundance of essential nutrients, 
                        which make them a valuable addition to any diet. Rich in high-quality 
                        proteins, eggs provide the body with all nine essential amino acids 
                        necessary for muscle growth and repair. They are also a good source 
                        of vitamins A, D and B12, crucial for maintaining healthy vision, bone 
                        strength, and nerve function, respectfully. Additionally, despite previous 
                        concerns about cholesterol. Research suggests that moderate egg consumption 
                        can actually improve cholesterol levels by increases levels of HDL cholesterol 
                        (AKA the “good cholesterol”). With their versatility and nutrient density, 
                        eggs offer a convenient and affordable way to support overall health and well-being. </p>

                  
                    <h3 className='my-5'>Nutrients in Eggs</h3>
                    <div>
                      <p className='content'>1. Iron: Carries oxygen to cells throughout the body</p>
                      <p className='content'> 2. Vitamin A: Helps maintain healthy skin & eye tissue; assists in night vision </p>
                      <p className='content'>3. Vitamin D: Strengthens bones, teeth & immune system; Protects against autoimmune disease. </p>
                      <p className='content'> 4. Vitamin E: maintains good health & prevents disease.</p>
                      <p className='content'>5. Vitamin B12: Benefits the nervous system and keeps blood cells healthy.</p>
                      <p className='content'> 6. Folate: Helps produce & maintain new cells </p>
                      <p className='content'>7. Selenium: Helps to prevent breakdown of body tissues.</p>
                      <p className='content'> 8. Lutein & zeaxanthin: Helps maintain good vision; Protects against cataracts & macular degeneration.</p>
                      <p className='content'> 9. Choline: Supports brain development & function.</p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW3" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>
    
          </ScrollTop>
    
          <Footer />
    
          </Fragment>
        );
      }
    }
    
    export default withRouter(Case);